export default __webpack_public_path__ + "static/media/banner1.f6b82ea2.png";